import Loader from '../Loader/Loader';
import { DICTIONARY_STATUS, useLocalization } from './LocalizationContext';

/**
 * Holds the app behind the loader until the backend dictionaries settle, so no screen paints
 * the bundled text first and swaps it a moment later.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The app.
 * @returns {JSX.Element} The loader while loading, the children afterwards.
 * @author armandoricosandoval -ai-
 */
const DictionaryGate = ({ children }) => {
  const { status } = useLocalization();
  return status === DICTIONARY_STATUS.LOADING ? <Loader /> : children;
};

export default DictionaryGate;
